import MenuDrop from '../components/menu-drop.vue';
import DiscoveryToolIntegration from './discovery-tool-integration.vue';
export default {
  components: {
    MenuDrop,
    DiscoveryToolIntegration
  },
  props: {
    environment: {
      type: String,
      required: true
    }
  }
};